// Initial state: array of modal objects
const initialState = {
    active: [],
    history: []
};

export const modalsReducer = (state = initialState, action) => {
    switch (action.type) {
    case "MODAL_OPEN": {
        const modal = action.payload;

        const exists = state.active.some(
            m => m.uniqueKey && m.uniqueKey === modal.uniqueKey
        );

        if (modal.uniqueKey && exists) {
            return state;
        }

        return {
            ...state,
            active: [...state.active, modal]
        };
    }

    case "MODAL_CLOSE": {
        return {
            ...state,
            active: state.active.filter(m => m.id !== action.payload)
        };
    }
    case "MODAL_CLOSE_TOP": {
        return {
            ...state,
            active: state.active.slice(0, -1)
        };
    }
    default:
        return state;
    }
};

// Action creators
export const openModal = (modal) => ({ type: "MODAL_OPEN", payload: modal });
export const closeModal = (id) => ({ type: "MODAL_CLOSE", payload: id });
export const closeAllModals = () => ({ type: "MODAL_CLOSE_ALL" });
export const closeTopModal = () => ({ type: "MODAL_CLOSE_TOP" });